


































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class RelatedApprovalInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '关联审批单',
    placeholder: '请选择',
    type: '请选择',
    required: false,
  };
  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
